const columns = [
  {
    title: "NO.",
    key: "index",
    render: (text, record, index) => <span>{index + 1}</span>,
  },
  {
    title: "KODE CABANG",
    dataIndex: "kdcab",
    key: "kdcab",
    render: (text) => <a>{text || "-"}</a>,
  },
  {
    title: "KODE DEALER",
    dataIndex: "kddealer",
    key: "kddealer",
    render: (text) => <a>{text || "-"}</a>,
  },
  {
    title: "NAMA DEALER",
    dataIndex: "namadealer",
    key: "namadealer",
    render: (text) => <a>{text || "-"} </a>,
  },
  {
    title: "NAMA PEMILIK",
    dataIndex: "pemilik",
    key: "pemilik",
    render: (text) => <a>{text || "-"} </a>,
  },
  {
    title: "STATUS",
    dataIndex: "is_approved",
    key: "is_approved",
    render: (value) => {
      let label = "";
      let bgColor = "";

      if (value === true) {
        label = "APPROVED";
        bgColor = "#28a745"; // hijau
      } else if (value === false) {
        label = "REJECTED";
        bgColor = "#dc3545"; // merah
      } else {
        label = "WAITING";
        bgColor = "#ffc107"; // kuning (waiting)
      }

      const style = {
        display: "inline-block",
        padding: "6px 12px",
        borderRadius: "6px",
        fontWeight: "bold",
        color: "white",
        backgroundColor: bgColor,
        textTransform: "uppercase",
      };

      return <span style={style}>{label}</span>;
    },
  },
];

export { columns };
